import {
	IAbmStructureResponse,
	IFieldStructure
} from 'constants/valuesInterfaces/interfaces'
import { FormikProps } from 'formik'
import i18next from 'i18next'
import { WithTranslation } from 'react-i18next'
import {
	ICrudCompleteFields,
	ICrudFieldStructure,
	ICrudGenericFields,
	IDependsOn
} from './CrudInterface'
import { IHistory } from './NavigationInterface'
import { IResponseResult } from './ResultsInterface'
import {
	IHeaderFilter,
	ITableWithSelectionEditableField
} from './TableWithSelection'

export interface IPricesListsMassiveUpdateProps extends WithTranslation {
	t: i18next.TFunction
	config: IProcessConfigResponse
	idOperacion?: number
	selectSearchedProducts: (payload: {
		values: any
		idOperacion: String
	}) => void
	getTablePricesListsProductsAutoComplete: (lk_prod_lp: String) => void
	getTablePricesListsAutocomplete: (copia_pc: String) => void
	getTablePricesLists: (idCliente: String) => void
	getConfigFieldsCrud: (payload: { cod_abm: string }) => void
	pricesListsUpdateApply: (payload: IPricesListsUpdateApply) => void
	pricesListsUpdateRecord: (payload: IPricesListsUpdateRecord) => void
	pricesListsUpdatePaginate: (payload: IPricesListsUpdatePaginate) => void
	fieldsConfig: IAbmStructureResponse
	selectedProducts: ISelectedProducts
	listsAutocomplete: IListsAutocomplete
	pricesLists: IPriceLists
	pricesListsUpdateApplied: IPricesListsUpdateApplyRes
	pricesListsUpdateRecorded: IPricesListsUpdateRecordRes
	pricesListsUpdatePaginated: IPricesListsUpdatePaginateRes
	history: IHistory
	gridProducts: IGridProducts
	voucherCancel: ({ idOperacion }: any) => void
	gridFilters?: IPricesListsUpdateApplyRes
}

export interface IPricesListsMassiveUpdateState {
	showSearchModal: boolean
	action: IAction
	isSearching: boolean
	idCliente: String
	showConfirmModal: boolean
	disableForm: boolean
	errorMessage: String
	lk_sel_list: String
	searchParams: {
		filtro_desc_prod: string
		filtro_desc_lp: string
		filtro_desc_catprod: string
		page_number: number
		page_size: number
		total_count: number
		idOperacion: number
	}
}

export interface IPricesListsMassiveUpdateTableProps extends WithTranslation {
	idOperacion?: number
	tableFields: Array<ICrudFieldStructure>
	disableForm: boolean
	fields: IGridProducts
	t?: i18next.TFunction
	handleChangeTable: (
		type: String,
		pagination: any,
		field: ITableWithSelectionEditableField
	) => void
	gridFilters: Array<IHeaderFilter>
}
export interface IPricesListsMassiveUpdateTableState {
	showEditPopup: boolean
}
export interface IPricesListsMassiveUpdateDiscountFormProps {
	fields: Array<ICrudFieldStructure>
	idOperacion: any
	isSearching: boolean
	disableForm: boolean
	handleIsSearching: (isSearching: boolean) => void
	handleSearchPricesLists: (copia_pc: String) => void
	handlePricesListsApply: (payload: IPricesListsUpdateApply) => void
	handlePricesListsRecord: (confirm: ConfirmType, action: ActionType) => void
	handleConfirmModal: (payload: boolean) => void
	handleCancelRedirect: () => void
	listsAutocomplete: IListsAutocomplete
	actionCode: String
	showConfirmModal: boolean
	errorMessage: String
	action: IAction
	lk_sel_list: String
}

export interface IPricesListsMassiveUpdateDiscountFormState {
	action: ActionType
	showCancelModal: boolean
	forma_red: String
	redondeo: String
}
export interface IPricesListsMassiveUpdateDiscountFormFieldProps {
	field: ICrudFieldStructure
	formikProps: FormikProps<any>
	crudProps: any
	initialValue: any
	listsAutocomplete: IListsAutocomplete
	isSearching: boolean
	handleIsSearching: (isSearching: boolean) => void
	handleSearchPricesLists: (copia_pc: String) => void
	handleFormaRedondeoChange: (value: String) => void
	handleRedondeoChange: (value: String) => void
}

export interface IPricesListsMassiveUpdateDiscountFormFieldState {
	dependsOn: IDependsOn
	fieldConfig: ICrudGenericFields
	defaultValue?: string
	idField?: any
	value?: any
}
export interface IPricesListsMassiveUpdateHeaderFormProps {
	fields: Array<ICrudFieldStructure>
	handleActionChange: (param: IActionChangeParams) => void
}

export interface IPricesListsMassiveUpdateHeaderFormFieldProps {
	field: ICrudFieldStructure
	formikProps: FormikProps<any>
	crudProps: any
	initialValue: any
	handleActionChange: (value: String) => void
}

export interface IPricesListsMassiveUpdateHeaderFormFieldState {
	dependsOn: IDependsOn
	fieldConfig: ICrudGenericFields
	defaultValue?: string
	idField: string
}
export interface IPricesListsMassiveUpdateListFormProps {
	fields: Array<ICrudFieldStructure>
	idOperacion: number
	handleClientsPricesLists: (idCliente: String) => void
	handleRedirectPriceList: () => void
	handleSelectListValue: (param: ISelectListValueParam) => void
	pricesLists: IPriceLists
}
export interface IPricesListsMassiveUpdateListFormState {
	isSearchingClients: boolean
	isSearchingProducts: boolean
}
export interface IPricesListsMassiveUpdateListFormFieldsProps {
	field: ICrudFieldStructure
	formikProps: FormikProps<any>
	crudProps: any
	initialValue: any
	handleClientsPricesLists: (idCliente: String) => void
	handleSearchClients: (criterio_cliente: String) => void
	handleSearchProducts: (lk_prod_lp: String) => void
	selectionType: IListSelectionType
	listProducts: IProductsList
	listClients: IClientsList
	pricesLists: IPriceLists
	handleIsSearchingProducts: (isSearchingProducts: boolean) => void
	handleIsSearchingClients: (isSearchingClients: boolean) => void
	isSearchingClients: boolean
	isSearchingProducts: boolean
	handleSelectListValueChange: (value: String) => void
}
export interface IPricesListsMassiveUpdateListFormFieldsState {
	dependsOn: IDependsOn
	fieldConfig: ICrudGenericFields
	defaultValue?: string
	idField: string
}
export interface IPricesListsMassiveUpdateProductFormProps {
	fields: Array<ICrudCompleteFields>
	handleOpenModal: () => void
	selectedProducts: ISelectedProducts
	action: IAction
}
export interface IPricesListsMassiveUpdateProductFormFieldsProps {
	field: ICrudCompleteFields
	formikProps: FormikProps<any>
	crudProps: any
	initialValue: any
	handleOpenModal: () => void
	selectedProducts: ISelectedProducts
}

export interface IPricesListsMassiveUpdateProductFormFieldsState {
	dependsOn: IDependsOn
	fieldConfig: ICrudGenericFields
	defaultValue?: string
	idField: any
}
export interface IPricesListsUpdateApply {
	idOperacion: number
	lk_cod_prod?: String
	lk_categ_prod?: String
	lk_desc_prod?: String
	lk_sel_list?: String
	tipo_pc: String
	pc_sum: number
	pc_nuevo: number
	opc_pc: String
	redondeo: String
	cant_dec: number
	filtro_desc_prod?: Array<string>
	filtro_desc_lp?: Array<string>
	filtro_desc_catprod?: Array<string>
	forma_red: String
}
export interface IPricesListsUpdateRecord {
	idOperacion: number
	accion: number
	confirmar: number
}
export interface IPricesListsUpdatePaginate {
	idOperacion: number
	page_size: number
	page_number: number
}
export interface IPricesListsUpdateRecordRes {
	Resultado: IResponseResult
	id: String
}
export interface IPricesListsUpdatePaginateRes {
	Resultado: IResponseResult
	id: String
	page_size: number
	page_number: number
	total_count: number
	lista: Array<IListaProdAttributes>
	filtro_desc_lp: Array<string>
	filtro_desc_prod: Array<string>
	filtro_desc_catprod: Array<string>
}
export interface IPricesListsUpdateApplyRes {
	Resultado: IResponseResult
	id: String
	page_size: number
	page_number: number
	total_count: number
	lista: Array<IListaProdAttributes>
	filtro_desc_lp: Array<string>
	filtro_desc_prod: Array<string>
	filtro_desc_catprod: Array<string>
}
export interface IListaProdAttributes {
	nro: number
	niprod: number
	desc_lp: String
	desc_prod: String
	cod_prod: String
	cod_barra: null
	desc_catprod: String
	costo: number
	precio: number
	pc: number
	pc_nuevo: number
	forma_calc: String
	precio_nuevo: number
}

export interface IPricesListsUpdateApplySaga {
	type: string
	payload: IPricesListsUpdateApply
}
export interface IPricesListsUpdateRecordSaga {
	type: string
	payload: IPricesListsUpdateRecord
}
export interface IPricesListsUpdatePaginateSaga {
	type: string
	payload: IPricesListsUpdatePaginate
}
export enum ActionType {
	NONE,
	APPLY,
	DELETE,
	CANCEL
}
export enum ConfirmType {
	NO_CONFIRM,
	CONFIRM
}
export interface IActionChangeParams {
	codigo: String
	descrip: String
	texto: String
}
export interface IActionResp {
	lista: Array<IActionChangeParams>
	Resultado: IResponseResult
}
export interface ISelectListValueParam {
	codigo: String
	descrip: String
}

export interface IProcessConfigResponse {
	campos: Array<IFieldStructure>
	cod_proceso: string
	desc_proceso: string
	fin_comprobante: number
	hay_adicionales: number
	idComprobante: number
	idEmpresa: number
	order: number
}
export interface ISelectedProducts {
	Resultado: IResponseResult
	mensaje: String
	total_count: number
}
export interface IPriceLists {
	Descrip: String
	resultado: IResponseResult
}
export interface IListsAutocomplete {
	lista: Array<IAutoCompleteResp>
	resultado: IResponseResult
}
export interface IAutoCompleteResp {
	cod_preclis: String
	descrip: String
}

export interface IListSelectionType {
	lista: Array<ISelectionTypeResp>
	resultado: IResponseResult
}
export interface ISelectionTypeResp {
	codigo: String
	descrip: String
}
export interface IGridProducts {
	Resultado: IResponseResult
	filtro_desc_lp: Array<string>
	filtro_desc_prod: Array<string>
	filtro_desc_catprod: Array<string>
	lista: Array<IListaProdAttributes>
	page_number: number
	page_size: number
	total_count: number
}
export interface IAction {
	code: String
	text: String
}
export interface IClientsList {
	clientes: Array<ICliente>
	resultado: IResponseResult
}
export interface ICliente {
	Clave_impo: string
	Cod_cliente: string
	Cpos: string
	Direccion: string
	Localidad: string
	Provincia: string
	Rsocial: string
	idCliente: number
}
export interface IProductsList {
	clientes: Array<IProduct>
	resultado: IResponseResult
}
export interface IProduct {
	niprod: string
	descrip: string
}
export interface IOptions {
	lista: Array<IOption>
	resultado: IResponseResult
}
export interface IOption {
	codigo: string
	descrip: string
}
export interface ISearchClientsParams {
	criterio_cliente: String
	idOperacion: number
}
export interface IProductCategory {
	incluye_todos: number
}
